import '../../../../node_modules/@glidejs/glide/dist/css/glide.core.css'
import Glide from '@glidejs/glide'

const blockCarousel = {
  el: '',
  init() {
    this.el = $q('.block-carousel .glide')

    if (!this.el.first) return

    new Glide(this.el.first, {
      focusAt: 1,
      perView: 3,
      gap: 20,
      breakpoints: {
        1200: {
          perView: 1,
          focusAt: 'center'
        }
      }
    }).mount()
  }
}

export default blockCarousel
